import { Content } from '@wajeez/wajeez.microservices';

const FLOW_READER = 'flowReader';

export const setFlowReader = (flowReader: Content.FlowOutput) => {
  localStorage.setItem(FLOW_READER, JSON.stringify(flowReader));
};

export const getFlowReader = () => {
  const flowReader = localStorage.getItem(FLOW_READER);

  return flowReader ? JSON.parse(flowReader) : null;
};

export const removeFlowReader = () => {
  localStorage.removeItem(FLOW_READER);
};
